import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const landingPageRoute: InvariantJiraRoute = {
	// We name this virtualagentonboarding without the "-" as otherwise it would trigger
	// the nesting stack, which we don't want for onboarding
	name: 'project-settings-servicedesk-virtualagentonboarding',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent',
};
